import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryYearsLessThanOne extends AnnualSummaryError {
    numberOfYears;
    constructor(numberOfYears, options) {
        super('The number of years can not be less than one', options);
        this.numberOfYears = numberOfYears;
    }
}
export default AnnualSummaryYearsLessThanOne;
